import React, { useEffect, useState } from "react";
import {
  Card,
  Tabs,
  Button,
  Input,
  Row,
  Col,
  Tooltip,
  Avatar,
  Upload,
  Typography,
  Tag,
  Modal,
  Select,
  DatePicker,
  Flex,
  Form,
  notification,
  Skeleton,
  Space,
} from "antd";
import {
  UploadOutlined,
  UserOutlined,
  MailOutlined,
  DeleteOutlined,
  DownloadOutlined,
  EditOutlined,
  EyeOutlined,
} from "@ant-design/icons";
import moment from "moment";
import { IoLocationOutline } from "react-icons/io5";
import { FiPhone } from "react-icons/fi";
import { employee, resource } from "../api";
import { useLocation, useNavigate } from "react-router-dom";
import { set } from "./../../node_modules/moment/src/lib/locale/set";
import { userRole, employeeId } from "../utils/userDetails";
import logo from "../Assets/Images/back.png";

const { TabPane } = Tabs;
const { Option } = Select;

const attachment_type = {
  1: "Resume",
  2: "Certificate",
  3: "Others",
};

const ResourceDetails = () => {
  const location = useLocation();
  const { employeeNo, key } = location.state || {};
  const navigate = useNavigate();
  const [imageUrl, setImageUrl] = useState(null);
  const [attachments, setAttachments] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedAttachment, setSelectedAttachment] = useState(null);
  const [uploadDialogVisible, setUploadDialogVisible] = useState(false);
  const [uploadFile, setUploadFile] = useState(null);
  const [attachmentType, setAttachmentType] = useState("");
  const [description, setDescription] = useState("");
  const [issueDate, setIssueDate] = useState(null);
  const [expiryDate, setExpiryDate] = useState(null);
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const [form] = Form.useForm();
  const [resourceData, setResourceData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [basicDetails, setBasicDetails] = useState({});
  const [employeeList, setEmployeeList] = useState([]);
  const [updateLoading, setUpdateLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [attachmentLoading, setAttachmentLoading] = useState(false);
  const [uploadLoading, setUploadLoading] = useState(false);
  const [primarySkills, setPrimarySkills] = useState([]);
  const [secondarySkills, setSecondarySkills] = useState([]);
  const [selectOption, setSelectOption] = useState([]);
  const [secondarySelectOption, setSecondarySelectOption] = useState([]);
  const attachmentTypes = ["Resume", "Certificate", "Others"];
  const [atClient, setAtClient] = useState(resourceData[11] || "No");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [resumeUrl, setResumeUrl] = useState("");
  const [fileList, setFileList] = useState([]);
  const [documentType, setDocumentType] = useState("");
  const [activeTab, setActiveTab] = useState(key || "1");

  useEffect(() => {
    handleGetResourceDetails();
    getAllEmployeeList();
    getEmployeeAttachment();
  }, []);

  const handleGetResourceDetails = async () => {
    try {
      setLoading(true);
      const response = await resource.getResourceDetails({
        employeeNo: employeeNo || employeeId,
      });
      const apiData = response.data;

      const updatedResourceData = [
        {
          label: "Work Location",
          value: apiData.workingLocation || "None",
          field: "workingLocation",
        },
        {
          label: "Date Of Joining",
          value: apiData.dateOfJoin,
          field: "date_of_joining",
        },
        {
          label: "Team",
          value: apiData.team || "No Team",
          field: "team",
        },
        {
          label: "Primary Skills",
          value: apiData?.primary_skills?.join(", ") || "No Skills",
          field: "primary_skills",
        },
        {
          label: "Secondary Skills",
          value: apiData?.secondary_skills?.join(", ") || "No Skills",
          field: "secondary_skills",
        },
        {
          label: "Experience",
          value: apiData.experience || "No Experience",
          field: "Experience",
        },
        {
          label: "Billable",
          value: apiData.isBillable ? "Yes" : "No",
          field: "billable",
        },
        {
          label: "Available",
          value: apiData.available ? "Yes" : "No",
          field: "available",
        },
        {
          label: "Work Mode",
          value: apiData.workMode || "Onsite",
          field: "work_mode",
        },
        {
          label: "Reporting To",
          value: apiData.managerName || "None",
          field: "reporting_to",
        },
        {
          label: "At Client",
          value: apiData.atClient ? "Yes" : "No",
          field: "at_client",
        },
        {
          label: "Preferred Location",
          value: apiData.preferredLocation || "None",
          field: "preferred_location",
        },
        ...(userRole === "admin"
          ? [
              {
                label: "Remarks",
                value: apiData.remarks || "None",
                field: "remarks",
              },
            ]
          : []),
        {
          label: "Project",
          value: (
            <>
              {apiData.projectDetails?.length > 0 ? (
                <table style={{ width: "100%", border: "1px solid #ccc" }}>
                  <thead>
                    <tr>
                      <th style={{ textAlign: "left", padding: "8px" }}>
                        Project Name
                      </th>
                      <th style={{ padding: "8px" }}>Start Date</th>
                      <th style={{ padding: "8px" }}>End Date</th>
                      <th style={{ padding: "8px" }}>Billable</th>
                      <th style={{ padding: "8px" }}>Project Type</th>
                      <th style={{ padding: "8px" }}>Completed(in %)</th>
                    </tr>
                  </thead>
                  <tbody>
                    {apiData.projectDetails?.length > 0 ? (
                      apiData.projectDetails.map((project) => (
                        <tr key={project.projectId}>
                          <td style={{ padding: "8px" }}>
                            {project.projectName}
                          </td>
                          <td style={{ padding: "8px", textAlign: "center" }}>
                            {project.startDate}
                          </td>
                          <td style={{ padding: "8px", textAlign: "center" }}>
                            {project.endDate}
                          </td>
                          <td style={{ padding: "8px", textAlign: "center" }}>
                            {project.isBillable ? "Yes" : "No"}
                          </td>
                          <td style={{ padding: "8px", textAlign: "center" }}>
                            {project.isInternal ? "Internal" : "Client"}
                          </td>
                          <td style={{ padding: "8px", textAlign: "center" }}>
                            {project?.percentageCompleted || 0}%
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td
                          colSpan={3}
                          style={{ textAlign: "center", padding: "8px" }}
                        >
                          No Projects
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              ) : (
                "No Projects"
              )}
            </>
          ),
          field: "project",
        },
      ];

      setResourceData(updatedResourceData);
      setBasicDetails({
        name: apiData.name,
        employeeNo: apiData.employeeNo,
        email: apiData.email,
        mobile: apiData.mobile,
        location: apiData.location,
        at_client: apiData.atClient ? "Yes" : "No",
      });
      setPrimarySkills(apiData.primary_skills || []);
      setSecondarySkills(apiData.secondary_skills || []);
      setAtClient(apiData.atClient ? "Yes" : "No");
      setLoading(false);
    } catch (error) {
      console.log("error", error);
      setLoading(false);
    }
  };

  const getAllEmployeeList = async () => {
    try {
      const response = await employee.getEmployeeList();
      const newResponse = response.data.map((employee) => {
        return {
          value: employee.employeeNo,
          label: `${employee.name}`,
        };
      });
      setEmployeeList(newResponse);
    } catch (error) {
      console.log("error", error);
    }
  };

  const getEmployeeAttachment = async () => {
    try {
      setUploadLoading(true);
      const response = await resource.getEmployeeAttachment({
        employeeNo: employeeNo || employeeId,
      });
      setAttachments(response.data);
      setUploadLoading(false);
    } catch (error) {
      console.log("error", error.message);
      setUploadLoading(false);
    }
  };

  const handleDelete = async () => {
    try {
      setDeleteLoading(true);
      await resource.deleteEmployeeAttachment({
        attachmentId: selectedAttachment.attachmentId,
      });

      setAttachments((prev) => {
        const attachmentType = selectedAttachment.attachmentType;

        return {
          ...prev,
          [attachmentType]: prev[attachmentType].filter(
            (attachment) =>
              attachment.attachmentId !== selectedAttachment.attachmentId
          ),
        };
      });
      setDeleteLoading(false);
      setOpenDialog(false);
    } catch (error) {
      console.error("Error deleting attachment:", error.message);
      setDeleteLoading(false);
    }
  };

  const handleDownload = (storedFilename) => {
    const link = document.createElement("a");
    link.href = storedFilename;
    link.target = "_blank";
    link.download = "";

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleView = (resumeUrl) => {
    setResumeUrl(resumeUrl?.link);
    setDocumentType(resumeUrl?.attachmentType);
    setIsModalVisible(true);
  };

  const closeViewModal = () => {
    setIsModalVisible(false);
    setResumeUrl("");
  };

  const openDeleteDialog = (attachment) => {
    setSelectedAttachment(attachment);
    setOpenDialog(true);
  };

  const closeDeleteDialog = () => {
    setOpenDialog(false);
  };

  const handleUploadDialogClose = () => {
    setUploadFile(null);
    setAttachmentType("");
    setFileList([]);
    setDescription("");
    setIssueDate(null);
    setExpiryDate(null);
    setUploadDialogVisible(false);
  };

  const handleFileChange = ({ fileList }) => {
    setFileList(fileList);
    if (fileList.length > 0) {
      setUploadFile(fileList[0].originFileObj);
    } else {
      setUploadFile(null);
    }
  };

  const handleValuesChange = (changedValues, allValues) => {
    if (changedValues.at_client !== undefined) {
      setAtClient(changedValues.at_client);
    }
  };

  const handleEditClick = () => {
    setIsEditModalVisible(true);

    const dateOfJoining = resourceData.find(
      (item) => item.field === "date_of_joining"
    )?.value;

    const initialValues = resourceData.reduce((acc, item) => {
      if (item.field === "date_of_joining") {
        acc[item.field] = moment(dateOfJoining, "YYYY-MM-DD");
      } else if (
        item.field === "primary_skills" ||
        item.field === "secondary_skills"
      ) {
        acc[item.field] =
          item.value && item.value.trim().toLowerCase() !== "no skills"
            ? item.value.split(",").map((skill) => skill.trim())
            : [];
      } else if (item.field == "reporting_to") {
        const reportingEmployee = employeeList.find(
          (employee) => employee.label == item.value
        );
        acc[item.field] = reportingEmployee
          ? reportingEmployee.value
          : item.value;
      } else {
        acc[item.field] = item.value;
      }
      return acc;
    }, {});

    form.setFieldsValue(initialValues);
  };

  const handleSave = () => {
    form
      .validateFields()
      .then((values) => {
        setUpdateLoading(true);
        const payload = {
          ...values,
          employeeNo: employeeNo || employeeId,
          reporting_to: values.reporting_to,
          primary_skills: primarySkills || values.primary_skills,
          secondary_skills: secondarySkills || values.secondary_skills,
        };
        const updatedData = resourceData.map((item) => ({
          ...item,
          value: payload[item.field],
        }));
        setResourceData(updatedData);

        resource
          .updateResourceDetails({ resourceDetails: payload })
          .then((response) => {
            console.log("API Response:", response.data);
            notification.success({
              message: "Resource details updated successfully!",
            });
            setUpdateLoading(false);
            handleGetResourceDetails();
            setIsEditModalVisible(false);
          })
          .catch((error) => {
            console.log("Error updating resource details:", error);
            notification.error({
              message: "Failed to update resource details",
            });
            setUpdateLoading(false);
          });
      })
      .catch((errorInfo) => {
        console.error("Validation Failed:", errorInfo);
        notification.error({
          message: "Please fill all required fields",
        });
        setUpdateLoading(false);
      });
  };

  const handleCancel = () => {
    setIsEditModalVisible(false);
  };

  const handlePrimarySkills = (values) => {
    const filtered = values
      .filter((v) => v && v.trim() !== "")
      .map((v) => v.trim());

    const unique = [...new Set(filtered)];
    setPrimarySkills(unique);
  };

  const handleSecondarySkills = (values) => {
    const filtered = values
      .filter((v) => v && v.trim() !== "")
      .map((v) => v.trim());

    const unique = [...new Set(filtered)];
    setSecondarySkills(unique);
  };

  const skillsSearch = async (val) => {
    try {
      if (val) {
        const response = await employee.getSkills(`?search=${val}`);
        setSelectOption(response?.data || []);
        setSecondarySelectOption(response?.data || []);
      }
    } catch (error) {
      console.error("Error fetching skills", error);
    }
  };

  const handleInputChange = (inputValue) => {
    if (inputValue.trim().length >= 3) {
      skillsSearch(inputValue.trim());
    } else if (inputValue.trim().length < 3) {
      setSelectOption([]);
      setSecondarySelectOption([]);
    }
  };

  const filterOption = (input, option) =>
    (option?.label ?? "").toLowerCase().includes(input.toLowerCase());

  const uploadEmployeeAttachment = async () => {
    try {
      if (!uploadFile || !attachmentType) {
        notification.error({
          message: "Please fill all fields before uploading.",
        });
        return;
      }

      if (uploadFile.size > 5 * 1024 * 1024) {
        notification.error({
          message: "File size exceeds the 5MB limit.",
        });
        return;
      }

      const allowedTypes = [
        "application/pdf",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "image/png",
        "image/jpeg",
      ];

      if (!allowedTypes.includes(uploadFile.type)) {
        notification.error({
          message: "Only PDF, DOCX, PNG, and JPG are allowed.",
        });
        return;
      }

      setAttachmentLoading(true);
      const newAttachment = {
        employeeNo: employeeNo || employeeId,
        attachment_type: attachmentType,
        description,
        issue_date: issueDate,
        expiry_date: expiryDate,
        file: uploadFile,
        created_by: employeeId,
      };

      const formData = new FormData();
      Object.entries(newAttachment).forEach(([key, value]) => {
        if (value) formData.append(key, value);
      });

      const response = await resource.uploadEmployeeAttachment(formData);
      console.log("API Response:", response.data);
      notification.success({
        message: "Attachment uploaded successfully!",
      });
      setAttachmentLoading(false);
      getEmployeeAttachment();
      setUploadFile(null);
      setFileList([]);
      handleUploadDialogClose();
    } catch (error) {
      console.log("Error uploading attachment:", error);
      notification.error({
        message: "Failed to upload attachment.",
      });
      setAttachmentLoading(false);
    }
  };

  const handleUploadDialogOpen = (type) => {
    setAttachmentType(type);
    setUploadDialogVisible(true);
  };

  const skeletonUploadCard = (
    <Card
      style={{
        width: "300px",
        height: "180px",
        border: "1px dashed #d9d9d9",
        borderRadius: 8,
        textAlign: "center",
      }}
      bordered={false}
    >
      <Skeleton.Button
        active
        shape="round"
        style={{ width: "40px", height: "40px", marginBottom: "8px" }}
      />
      <Skeleton.Input active style={{ width: "80%", marginTop: "8px" }} />
      <Skeleton.Input active style={{ width: "20%" }} />
    </Card>
  );

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <Card
      style={{ maxWidth: "1900px" }}
      title={
        <>
          {loading ? (
            <Space direction="vertical" size="large" style={{ width: "100%" }}>
              <div
                style={{ display: "flex", alignItems: "center", gap: "16px" }}
              >
                <Skeleton.Avatar active size={64} shape="circle" />
                <div style={{ flex: 1 }}>
                  <Skeleton
                    active
                    title={false}
                    paragraph={{ rows: 4, width: ["50%", "70%", "40%"] }}
                  />
                </div>
              </div>
            </Space>
          ) : (
            <Row align="middle" flex={0}>
              <span style={{ cursor: "pointer" }} onClick={handleBack}>
                <img
                  style={{ width: "30px", height: "45px" }}
                  src={logo}
                  alt="Back Arrow"
                />
              </span>
              <Col>
                <Row align="middle" gutter={16} style={{ height: "120px" }}>
                  <Col>
                    <Avatar
                      size={90}
                      src={imageUrl}
                      icon={!imageUrl && <UserOutlined />}
                      style={{ backgroundColor: "#87d068", cursor: "pointer" }}
                    />
                  </Col>
                  <Col>
                    <div style={{ fontWeight: "bold", fontSize: "28px" }}>
                      {basicDetails.name}
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        gap: "80px",
                      }}
                    >
                      <div>
                        <div style={{ color: "#8c8c8c" }}>
                          {basicDetails.employeeNo}
                        </div>
                        <div
                          style={{
                            color: "#8c8c8c",
                            display: "flex",
                            alignItems: "center",
                            gap: "7px",
                          }}
                        >
                          {basicDetails.location && <IoLocationOutline />}{" "}
                          {basicDetails.location}
                        </div>
                      </div>
                      <div>
                        <div style={{ color: "#8c8c8c" }}>
                          {basicDetails.email && <MailOutlined />} &nbsp;
                          {basicDetails.email}
                        </div>
                        <div
                          style={{
                            color: "#8c8c8c",
                            display: "flex",
                            alignItems: "center",
                            gap: "7px",
                          }}
                        >
                          {basicDetails.mobile && <FiPhone />}{" "}
                          {basicDetails.mobile}
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
          )}
        </>
      }
    >
      {!loading && activeTab === "1" && (
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <Button type="primary" onClick={handleEditClick}>
            <EditOutlined />
            Edit
          </Button>
        </div>
      )}

      <Tabs
        defaultActiveKey={key || "1"}
        onChange={(activeKey) => setActiveTab(activeKey)}
      >
        <TabPane tab="RESOURCE INFO" key="1">
          {loading ? (
            <span
              style={{
                height: "300px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginTop: "20px",
              }}
            >
              <Skeleton
                active
                paragraph={{
                  rows: 10,
                  width: [
                    "50%",
                    "60%",
                    "40%",
                    "70%",
                    "80%",
                    "60%",
                    "50%",
                    "40%",
                    "90%",
                    "80%",
                  ],
                }}
              />
            </span>
          ) : (
            <div style={{ marginBottom: "20px" }}>
              {resourceData.map((item, index) => (
                <Row
                  key={index}
                  style={{
                    marginBottom: "10px",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <Col style={{ flex: 0.5 }}>
                    <Typography.Text strong>{item.label}</Typography.Text>
                  </Col>
                  <Col style={{ flex: 1, textAlign: "center" }}> : </Col>
                  <Col style={{ flex: 4 }}>
                    <Typography.Text>{item.value}</Typography.Text>
                  </Col>
                </Row>
              ))}
            </div>
          )}
        </TabPane>

        <TabPane tab="ATTACHMENT" key="2">
          {uploadLoading ? (
            <span
              style={{
                marginTop: "20px",
              }}
            >
              <Row gutter={[16, 16]} style={{ gap: "16px" }}>
                <Col span={24} style={{ display: "flex", gap: "10px" }}>
                  {skeletonUploadCard} {skeletonUploadCard} {skeletonUploadCard}
                </Col>
                <Col span={24} style={{ display: "flex", gap: "10px" }}>
                  {skeletonUploadCard} {skeletonUploadCard}
                </Col>
                <Col span={24} style={{ display: "flex", gap: "10px" }}>
                  {skeletonUploadCard} {skeletonUploadCard} {skeletonUploadCard}
                </Col>
              </Row>
            </span>
          ) : (
            <Row
              gutter={[16, 16]}
              style={{ display: "flex", flexDirection: "column" }}
            >
              {attachmentTypes.map((type) => {
                const filteredAttachments = attachments?.[type] || [];

                const groupedAttachments = filteredAttachments.reduce(
                  (acc, attachment) => {
                    if (!acc[attachment.attachmentType]) {
                      acc[attachment.attachmentType] = [];
                    }
                    acc[attachment.attachmentType].push(attachment);

                    return acc;
                  },
                  {}
                );

                return (
                  <React.Fragment key={type}>
                    {filteredAttachments.length === 0 && (
                      <Col
                        style={{
                          padding: "50px",
                          backgroundColor: "#f0f5ff",
                          borderRadius: "8px",
                          maxWidth: "290px",
                          width: "100%",
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          border: "1px dashed rgb(24, 144, 255)",
                          flexDirection: "column",
                          gap: "10px",
                          margin: "10px 0px 0px 10px",
                        }}
                        onClick={() => handleUploadDialogOpen(type)}
                      >
                        <Tag
                          color={
                            type === "Resume"
                              ? "blue"
                              : type === "Certificate"
                              ? "green"
                              : "red"
                          }
                          style={{
                            position: "absolute",
                            top: "-12px",
                            left: "18px",
                            zIndex: "2",
                          }}
                        >
                          {type == "Resume"
                            ? "Resume"
                            : type == "Certificate"
                            ? "Certificate"
                            : "Others"}
                        </Tag>

                        <Tooltip
                          title={`Upload ${
                            type == "Resume"
                              ? "Resume"
                              : type == "Certificate"
                              ? "Certificate"
                              : "Others"
                          }`}
                        >
                          <Button
                            icon={<UploadOutlined />}
                            style={{
                              fontSize: "24px",
                              width: "100%",
                              height: "100%",
                              border: "0px",
                              textAlign: "center",
                              backgroundColor: "rgb(240, 245, 255)",
                              color: "rgb(24, 144, 255)",
                              boxShadow: "none",
                            }}
                          />
                        </Tooltip>
                        <Typography.Text
                          style={{
                            display: "block",
                            color: "#1890ff",
                            marginBottom: "4px",
                            cursor: "pointer",
                          }}
                        >
                          Click here to upload{" "}
                          {type == "Resume"
                            ? "resume"
                            : type == "Certificate"
                            ? "certificate"
                            : "Others"}
                        </Typography.Text>
                      </Col>
                    )}
                    {Object.keys(groupedAttachments).map((type) => (
                      <Row
                        key={type}
                        style={{
                          padding: "10px",
                          borderRadius: "8px",
                          marginBottom: "15px",
                          display: "flex",
                          flexWrap: "wrap",
                          alignItems: "center",
                          gap: "20px",
                          position: "relative",
                          width: "100%",
                        }}
                      >
                        {groupedAttachments[type].map((attachment) => (
                          <>
                            <Row
                              style={{
                                backgroundColor: "rgb(240, 245, 255)",
                                padding:
                                  type === "certificate"
                                    ? "12px 10px"
                                    : "10px 10px",
                                border: "1px solid rgb(24, 144, 255)",
                                borderRadius: "8px",
                                height: "170px",
                                width: "295px",
                                justifyContent: "space-between",
                              }}
                            >
                              <Col
                                key={attachment.id}
                                style={{
                                  padding: "10px",
                                  borderRadius: "8px",
                                  marginRight: "15px",
                                  width: "70%",
                                }}
                              >
                                <Tag
                                  color={
                                    type === "Resume"
                                      ? "blue"
                                      : type === "Certificate"
                                      ? "green"
                                      : "red"
                                  }
                                  style={{
                                    position: "absolute",
                                    top:
                                      type === "Certificate"
                                        ? "-25px"
                                        : "-20px",
                                    zIndex: "2",
                                  }}
                                >
                                  {type == "Resume"
                                    ? "Resume"
                                    : type == "Certificate"
                                    ? "Certificate"
                                    : "Others"}
                                </Tag>
                                <Typography.Text
                                  strong
                                  style={{
                                    display: "block",
                                    color: "#1890ff",
                                    marginBottom: "4px",
                                    cursor: "pointer",
                                  }}
                                  ellipsis={{ tooltip: attachment?.fileName }}
                                >
                                  {attachment?.fileName?.length > 25
                                    ? `${attachment?.fileName.substring(
                                        0,
                                        22
                                      )}...`
                                    : attachment?.fileName}
                                </Typography.Text>
                                <Typography.Text
                                  style={{ fontSize: "12px", color: "#595959" }}
                                >
                                  {`Date: ${new Date(
                                    attachment?.createdAt
                                  ).toLocaleDateString()}`}
                                </Typography.Text>
                                {attachment?.issueDate &&
                                  attachment?.expiryDate && (
                                    <>
                                      <br />
                                      <Typography.Text
                                        style={{
                                          fontSize: "12px",
                                          color: "#595959",
                                        }}
                                      >
                                        {`Issue Date: ${new Date(
                                          attachment?.issueDate
                                        ).toLocaleDateString()}`}
                                      </Typography.Text>{" "}
                                      <br />
                                      <Typography.Text
                                        style={{
                                          fontSize: "12px",
                                          color: "#595959",
                                        }}
                                      >
                                        {`Expiry Date: ${new Date(
                                          attachment?.expiryDate
                                        ).toLocaleDateString()}`}
                                      </Typography.Text>
                                    </>
                                  )}
                                <br />
                                <Typography.Text
                                  style={{ fontSize: "12px", color: "#595959" }}
                                >
                                  {`Uploaded By: ${attachment?.createdByName}`}
                                </Typography.Text>
                                <Typography.Text
                                  type="secondary"
                                  style={{
                                    display: "block",
                                    marginBottom: "4px",
                                    cursor: "pointer",
                                  }}
                                  ellipsis={{
                                    tooltip: attachment?.description,
                                  }}
                                >
                                  {attachment?.description?.length > 50
                                    ? `${attachment?.description.substring(
                                        0,
                                        48
                                      )}...`
                                    : attachment?.description}
                                </Typography.Text>
                              </Col>
                              <Col
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                }}
                              >
                                <Tooltip title="View">
                                  <Button
                                    type="link"
                                    icon={<EyeOutlined />}
                                    onClick={() => handleView(attachment)}
                                  />
                                </Tooltip>
                                <Tooltip title="Download">
                                  <Button
                                    type="link"
                                    icon={<DownloadOutlined />}
                                    onClick={() =>
                                      handleDownload(attachment?.link)
                                    }
                                  />
                                </Tooltip>
                                {userRole === "admin" && (
                                  <Tooltip title="Delete">
                                    <Button
                                      type="link"
                                      danger
                                      icon={<DeleteOutlined />}
                                      onClick={() =>
                                        openDeleteDialog(attachment)
                                      }
                                    />
                                  </Tooltip>
                                )}
                              </Col>
                            </Row>
                          </>
                        ))}
                        <Col
                          style={{
                            padding: "50px",
                            backgroundColor: "#f0f5ff",
                            borderRadius: "8px",
                            maxWidth: "295px",
                            width: "100%",
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            border: "1px dashed rgb(24, 144, 255)",
                            flexDirection: "column",
                            gap: "10px",
                            height: "170px",
                          }}
                          onClick={() => handleUploadDialogOpen(type)}
                        >
                          <Tag
                            color={
                              type === "Resume"
                                ? "blue"
                                : type === "Certificate"
                                ? "green"
                                : "red"
                            }
                            style={{
                              position: "absolute",
                              top: "-12px",
                              left: "18px",
                              zIndex: "2",
                            }}
                          >
                            {type == "Resume"
                              ? "Resume"
                              : type == "Certificate"
                              ? "Certificate"
                              : "Others"}
                          </Tag>
                          <Tooltip
                            title={`Upload ${
                              type == "Resume"
                                ? "Resume"
                                : type == "Certificate"
                                ? "Certificate"
                                : "Others"
                            }`}
                          >
                            <Button
                              icon={<UploadOutlined />}
                              style={{
                                fontSize: "24px",
                                width: "100%",
                                height: "100%",
                                border: "0px",
                                textAlign: "center",
                                backgroundColor: "rgb(240, 245, 255)",
                                color: "rgb(24, 144, 255)",
                                boxShadow: "none",
                              }}
                            />
                          </Tooltip>
                          <Typography.Text
                            style={{
                              display: "block",
                              color: "#1890ff",
                              marginBottom: "4px",
                              cursor: "pointer",
                            }}
                          >
                            Click here to upload{" "}
                            {type == "Resume"
                              ? "resume"
                              : type == "Certificate"
                              ? "certificate"
                              : "Others"}
                          </Typography.Text>
                        </Col>
                      </Row>
                    ))}{" "}
                  </React.Fragment>
                );
              })}
            </Row>
          )}

          <Modal
            title="Confirm Delete"
            visible={openDialog}
            onCancel={closeDeleteDialog}
            onOk={handleDelete}
            okText="Delete"
            okButtonProps={{ danger: true }}
            confirmLoading={deleteLoading}
          >
            <Typography.Text>
              Are you sure you want to delete this attachment?
            </Typography.Text>
          </Modal>

          <Modal
            title="Upload Attachment"
            visible={uploadDialogVisible}
            onCancel={handleUploadDialogClose}
            onOk={uploadEmployeeAttachment}
            okText="Upload"
            confirmLoading={attachmentLoading}
          >
            <Upload
              onChange={handleFileChange}
              beforeUpload={() => false}
              accept=".pdf,.docx,.png,.jpg"
              maxCount={1}
              fileList={fileList}
            >
              <Button icon={<UploadOutlined />}>Select File</Button>
            </Upload>

            <Select
              placeholder="Select Attachment Type"
              value={attachmentType}
              onChange={(value) => setAttachmentType(value)}
              style={{ marginTop: "10px", width: "100%" }}
            >
              {Object.entries(attachment_type).map(([key, type]) => (
                <Option
                  key={key}
                  value={type}
                  disabled={attachmentType !== type && attachmentType !== ""}
                >
                  {type}
                </Option>
              ))}
            </Select>
            {attachmentType === "certificate" && (
              <Flex gap="25px">
                <DatePicker
                  placeholder="Select Issue Date"
                  onChange={(date, dateString) => setIssueDate(dateString)}
                  style={{ marginTop: "10px", width: "100%" }}
                />
                <DatePicker
                  placeholder="Select Expiry Date"
                  onChange={(date, dateString) => setExpiryDate(dateString)}
                  style={{ marginTop: "10px", width: "100%" }}
                />
              </Flex>
            )}
            <Input.TextArea
              placeholder="Description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              style={{ marginTop: "10px" }}
            />
          </Modal>

          <Modal
            title={documentType}
            visible={isModalVisible}
            footer={null}
            onCancel={closeViewModal}
            width="80%"
            style={{ top: 20 }}
          >
            <iframe
              src={resumeUrl}
              width="100%"
              height="600px"
              title="Resume PDF"
            />
          </Modal>
        </TabPane>
      </Tabs>

      <Modal
        title="Edit Resource Info"
        visible={isEditModalVisible}
        onOk={handleSave}
        onCancel={handleCancel}
        okText="Save"
        cancelText="Cancel"
        width="40vw"
        confirmLoading={updateLoading}
      >
        <Form
          form={form}
          layout="vertical"
          initialValues={{
            ...basicDetails,
          }}
          onValuesChange={handleValuesChange}
        >
          <Flex gap="15px">
            <Form.Item
              label="Work Location"
              name="workingLocation"
              rules={[{ required: true, message: "Please enter Location" }]}
              style={{ width: "100%" }}
            >
              <Input disabled={userRole == "admin" ? false : true} />
            </Form.Item>

            <Form.Item
              label="Team"
              name="team"
              rules={[{ required: true, message: "Please enter Team" }]}
              style={{ width: "100%" }}
            >
              <Select disabled={userRole == "admin" ? false : true}>
                <Option value="5G">5G</Option>
                <Option value="AI/ML">AI/ML</Option>
                <Option value="Apps">Apps</Option>
                <Option value="BA">BA</Option>
                <Option value="Cloud">Cloud</Option>
                <Option value="Embd.">Embd.</Option>
                <Option value="Finance">Finance</Option>
                <Option value="GNSS">GNSS</Option>
                <Option value="HR">HR</Option>
                <Option value="Ops">Ops</Option>
                <Option value="PP">PP</Option>
                <Option value="QA">QA</Option>
                <Option value="TA">TA</Option>
                <Option value="UI/UX">UI/UX</Option>
                <Option value="US TA">US TA</Option>
              </Select>
            </Form.Item>
          </Flex>

          <Form.Item
            label="Primary Skills"
            name="primary_skills"
            style={{ width: "100%" }}
          >
            <Select
              mode="tags"
              onChange={handlePrimarySkills}
              onSearch={handleInputChange}
              placeholder="Enter your skills"
              style={{ width: "100%" }}
              allowClear
              filterOption={false}
              onInputKeyDown={(e) => {
                const value = e.target.value;

                if (e.key === "Enter") {
                  e.preventDefault();
                  if (value && value.trim() !== "") {
                    const commaSeparated = value
                      .split(",")
                      .map((v) => v.trim())
                      .filter((v) => v !== "");

                    if (commaSeparated.length > 0) {
                      handlePrimarySkills([
                        ...primarySkills,
                        ...commaSeparated,
                      ]);
                    }
                    e.target.value = "";
                  }
                }
              }}
              onPaste={(e) => {
                const paste = e.clipboardData.getData("text");
                if (paste.includes(",")) {
                  e.preventDefault();
                  const commaSeparated = paste
                    .split(",")
                    .map((v) => v.trim())
                    .filter((v) => v !== "");

                  if (commaSeparated.length > 0) {
                    const updatedSkills = [
                      ...new Set([...primarySkills, ...commaSeparated]),
                    ];
                    handlePrimarySkills(updatedSkills);

                    const newOptions = commaSeparated
                      .filter(
                        (skill) =>
                          !selectOption.some((opt) => opt.skill === skill)
                      )
                      .map((skill, index) => ({
                        id: `custom-${Date.now()}-${index}`,
                        skill,
                      }));
                    setSelectOption([...selectOption, ...newOptions]);
                  }
                }
              }}
            >
              {selectOption &&
                selectOption.length > 0 &&
                selectOption.map((skill) => (
                  <Option key={skill.id} value={skill.skill}>
                    {skill.skill}
                  </Option>
                ))}
            </Select>
          </Form.Item>

          <Form.Item
            label="Secondary Skills"
            name="secondary_skills"
            style={{ width: "100%" }}
          >
            <Select
              mode="tags"
              onChange={handleSecondarySkills}
              onSearch={handleInputChange}
              placeholder="Enter your skills"
              style={{ width: "100%" }}
              allowClear
              filterOption={false}
              onInputKeyDown={(e) => {
                const value = e.target.value;
                if (e.key === "Enter") {
                  e.preventDefault();
                  if (value && value.trim() !== "") {
                    const commaSeparated = value
                      .split(",")
                      .map((v) => v.trim())
                      .filter((v) => v !== "");

                    if (commaSeparated.length > 0) {
                      handleSecondarySkills([
                        ...secondarySkills,
                        ...commaSeparated,
                      ]);
                    }
                    e.target.value = "";
                  }
                }
              }}
              onPaste={(e) => {
                const paste = e.clipboardData.getData("text");
                if (paste.includes(",")) {
                  e.preventDefault();

                  const commaSeparated = paste
                    .split(",")
                    .map((v) => v.trim())
                    .filter((v) => v !== "");

                  if (commaSeparated.length > 0) {
                    const updatedSkills = [
                      ...new Set([...secondarySkills, ...commaSeparated]),
                    ];
                    handleSecondarySkills(updatedSkills);

                    const newOptions = commaSeparated
                      .filter(
                        (skill) =>
                          !secondarySelectOption.some(
                            (opt) => opt.skill === skill
                          )
                      )
                      .map((skill, index) => ({
                        id: `secondary-${Date.now()}-${index}`,
                        skill,
                      }));
                    setSecondarySelectOption([
                      ...secondarySelectOption,
                      ...newOptions,
                    ]);
                  }
                }
              }}
            >
              {secondarySelectOption &&
                secondarySelectOption.length > 0 &&
                secondarySelectOption.map((skill) => (
                  <Option key={skill.id} value={skill.skill}>
                    {skill.skill}
                  </Option>
                ))}
            </Select>
          </Form.Item>

          <Flex gap="15px">
            <Form.Item
              label="Available"
              name="available"
              rules={[
                { required: true, message: "Please select Availability" },
              ]}
              style={{ width: "100%" }}
            >
              <Select disabled={userRole == "admin" ? false : true}>
                <Option value="Yes">Yes</Option>
                <Option value="No">No</Option>
              </Select>
            </Form.Item>

            <Form.Item
              label="Reporting To"
              name="reporting_to"
              rules={[{ required: true, message: "Please enter Reporting To" }]}
              style={{ width: "100%" }}
            >
              <Select
                showSearch
                placeholder="Select an employee"
                filterOption={filterOption}
                optionFilterProp="children"
                options={employeeList}
                onChange={(value) => {
                  form.setFieldValue("reporting_to", value);
                }}
                disabled={userRole == "admin" ? false : true}
              ></Select>
            </Form.Item>
          </Flex>

          <Flex gap="15px">
            <Form.Item
              label="At Client"
              name="at_client"
              rules={[{ required: true, message: "Please select At Client" }]}
              style={{ width: "100%" }}
            >
              <Select disabled={userRole == "admin" ? false : true}>
                <Option value="Yes">Yes</Option>
                <Option value="No">No</Option>
              </Select>
            </Form.Item>

            <Form.Item
              label="Work Mode"
              name="work_mode"
              rules={[{ required: true, message: "Please select work mode" }]}
              style={{ width: "100%" }}
            >
              <Select disabled={userRole == "admin" ? false : true}>
                <Option value="Remote">Remote</Option>
                <Option value="Hybrid">Hybrid</Option>
                <Option value="Onsite">Onsite</Option>
              </Select>
            </Form.Item>
          </Flex>

          <Form.Item
            label="Preferred Location"
            name="preferred_location"
            rules={[
              { required: true, message: "Please enter Preferred Location" },
            ]}
          >
            <Input />
          </Form.Item>

          {userRole == "admin" && (
            <Form.Item
              label="Remarks"
              name="remarks"
            >
              <Input.TextArea rows={4} />
            </Form.Item>
          )}
        </Form>
      </Modal>
    </Card>
  );
};

export default ResourceDetails;
